
<template>
  <div class="mt-2 flex  overflow-hidden flex-grow ">
    <div class="overflow-hidden  flex flex-col pb-4 flex-grow bg-trader-gray mr-2 ">

      <!--go back  -->
      <div class="w-full  h-10 ">
        <CGoBack/>
      </div>

      <!--Bearbeitung Weißer hintergrund  -->
      <div class=" flex-grow overflow-hidden px-10 h-full  flex  text-center justify-center">

        <div class=" overflow-auto bg-white rounded p-10  max-w-[1000px] flex-grow">

          <div class="flex-grow flex flex-col container mx-auto bg-white rounded p-2 ">
            <div class="flex-shrink-0 flex items-center justify-between w-full h-10 mb-4 rounded">
              <div class="w-full bg-primary p-2 rounded">
                <span data-ui="ekb-context-headline" class="text-xl">
                  Neuen Einkaufsbereich
                </span>
              </div>
            </div>

            <div class="flex-grow flex flex-col space-y-4 overflow-auto">

              <div class="flex space-x-2">
                <span class="bg-primary w-[200px] p-2 rounded">Name</span>
                <input class="border p-2 rounded w-full "  v-model="iconName" :class="{'border p-2 rounded w-full border-red-500' : showError && !iconName}" data-ui="name">
              </div>

              <div class="flex space-x-2">
                <span class="bg-primary w-[200px] p-2 rounded">Beschreibung</span>
                <input class="border p-2 rounded w-full "  v-model="name" :class="{'border p-2 rounded w-full border-red-500' : showError && !name}" data-ui="description">
              </div>


              <div class="flex space-x-2">
                <span class="bg-primary w-[200px] p-2 rounded">Farbe</span>
                <div class="w-full bg-trader-gray p-2 rounded">
                  <input type="color" class="border rounded w-full" v-model="color" :class="{'border-red-500': showError && !color}"  data-ui="team-color">
                </div>
              </div>


              <button class="w-full rounded mt-2 p-3 bg-primary hover:bg-trader-blue hover:text-white transition duration-200 ease-in-out" @click="createTeam" data-ui="create-EKB-button">Erstellen</button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <sidebar />
  </div>
</template>

<script >
import sidebar from "@/components/Administration/Sidebar.vue";
import {gql} from "@apollo/client/core";
import apolloClient from "@/apolloClient";
import router from "@/router";
import {eventBus} from "@/application/EventBus";
import SuccessConfirmation from "@/components/Dialogs/SuccessConfirmation.vue";
import SignalBus from "@/application/SignalBus";
import CGoBack from "@/components/Administration/CGoBack.vue";

export default {
  components: {CGoBack, sidebar},
  data (){
    return{
      name: "",
      color: "",
      iconName: "",
      showError: false,
      accordionIndex: 0,
    }
  },
  methods: {
    goBack(){
      router.push(`/administration`);
    },
   async createTeam(){

      if(!this.name || !this.iconName){
        this.showError = true;
        return
      }
      this.showError = false;

        const teamData = {
          name: this.name,
          iconName: this.iconName,
         color: this.color.replace('#','') || '000000'
        };

        const mutation = gql`
        mutation createTeam($team: TeamInput!) {
          createTeam(team: $team) {
            success
          }
        }
      `;

        try {
          const variables = {
            team: teamData
          };
          const {data} = await apolloClient.mutate({mutation, variables});
          if (data.createTeam.success){
            eventBus.openModal(SuccessConfirmation);
            eventBus.setData({
              title: "Einkaufsbereich erstellt",
              message: "Der Einkaufsbereich wurde erstellt",
            });
            router.push(`/administration/${this.accordionIndex}`);
          }

        } catch (error) {
          console.error(error);
        }
     }
    },
  watch: {
    // get accordionIndex from url
    '$route.params.accordionIndex': function (newId, oldId) {
      this.accordionIndex = newId;
    },
  },
  created() {
    this.accordionIndex = this.$route.params.accordionIndex;
  },
}
</script>

